<template>
    <div class="section-img" :class="[section]">
      <!-- <img src="@/assets/section_img/kouza_sp.jpg"> -->
    </div>
</template>

<script>
export default {
    name: 'section-img',
    props:{
        section: String
    },
}
</script>

<style lang="scss" scoped>
.section-img {
  width: calc(100% + 100px);
  position: relative;
  padding-top: calc(25px + 27.4%);
  background-repeat: no-repeat;
  background-size: 100%;  
  background-position: center;
  margin-bottom: 5%;
  @media #{$maxM}{
    width: 100vw;
    padding-top: calc(10px + 57%);
  }
  &.bg-kouza {
    background-image: url('~@/assets/section_img/kouza.jpg');
    @media #{$maxM}{
      background-image: url('~@/assets/section_img/kouza_sp.jpg');
    }
  }
  &.bg-kanri {
    background-image: url('~@/assets/section_img/kanri.jpg');
    @media #{$maxM}{
      background-image: url('~@/assets/section_img/kanri_sp.jpg');
    }
  }
  &.bg-sindan {
    background-image: url('~@/assets/section_img/sindan.jpg');
    @media #{$maxM}{
      background-image: url('~@/assets/section_img/sindan_sp.jpg');
    }
  }
  &.bg-yobo {
    background-image: url('~@/assets/section_img/yobo.jpg');
    @media #{$maxM}{
      background-image: url('~@/assets/section_img/yobo_sp.jpg');
    }
  }
}
</style>